import { render } from "./vhpSlide.vue?vue&type=template&id=3b27cf61&scoped=true"
import script from "./vhpSlide.vue?vue&type=script&lang=js"
export * from "./vhpSlide.vue?vue&type=script&lang=js"

import "./vhpSlide.scss?vue&type=style&index=0&id=3b27cf61&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b27cf61"]])

export default __exports__